import { render, staticRenderFns } from "./OnboardingTenantStep.vue?vue&type=template&id=35b6f140&"
import script from "./OnboardingTenantStep.vue?vue&type=script&lang=js&"
export * from "./OnboardingTenantStep.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingTenantStep.vue?vue&type=style&index=0&id=35b6f140&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports